import React, { Component } from "react";

class Learn extends Component {
  render() {
    return (
      <div className="main-content">
        <div className="section-title standalone">
          <p>ABOUT STAREWAY FILMS</p>
          <div className="sep" />
        </div>

        <p className="aboutTextStyle">
          <br />
          <strong>WE PROVIDE THE GEAR</strong>
          <br />
          You’ve got vision. A passion for creating something from nothing. A
          story that you need to tell. But where do you even start? Stareway
          Films’ incredible variety of gear is the place. We provide
          high-quality, intuitive video and audio equipment to give you a
          foundation of versatility with any and all of your projects. Our
          priority is affordable rental prices that won’t inflate your budget,
          and keeps your focus on telling a great story with great
          collaborators. Got your dates for your shoot? What are you waiting
          for, then? Let’s get you going & making stuff!
          <br />
          <br />
          <br />
          <strong>LIGHT IT UP</strong>
          <br />
          Sure. We’ve got the gear. But we’re not about just giving you the keys
          to kingdom & sending you on your way. We’re invested in you! Any time
          you’re not sure what gear to get for your projects, our team will take
          the time to walk you through some options! You don’t just want
          whatever works. You want your vision to come to life in the best way
          that it possibly can! And so do we! Reach out to us to schedule an
          appointment & we’ll sit down with you to test out any and all
          equipment that you’re considering renting! Come workshop stuff with
          us!
          <br />
          <br />
          <br />
          <strong>HIRE US NOW</strong>
          <br />
          Sometimes? A project is too big to take on by yourself. And that’s
          okay! We’re here to help! Our team of filmmakers and artists can help
          collaborate with you on your productions in tandem with the resources
          Stareway Films already has at its disposal. Together, we can we bring
          your dream project to life in a fully realized way, maximizing each
          and every story’s potential. Are you a small business? A local company
          looking to make a leap with your online marketing presence? We can
          help with that too! Reach out to us today to connect with our team of
          creative, eclectic digital media artists, and we will begin the
          process of a creative partnership to promote your brand in the most
          forward thinking way imaginable. What are you waiting for? Connect
          with us today!
          <br />
          <br />
          <br />
          <strong>JOIN US TODAY</strong>
          <br />
          A film education isn’t about a degree. It’s a mindset and a lifetime
          pursuit to get better at your craft every day in every little way.
          Stareway Films’ unique and intimate workshops in filmmaking can not
          only offer you the opportunity to learn the knowledge to betterment
          your craft, but to connect with likeminded creators that you can bring
          into your collaborative fold. Filmmaking isn’t a one person medium. It
          takes a team. Dedicated your time and energy to become a better
          filmmaker! Come take a class with us!
          <br />
          <br />
          <br />{" "}
        </p>
      </div>
    );
  }
}

export default Learn;



// WEBPACK FOOTER //
// ./src/components/Learn.js